import { Component, EventEmitter, ViewChild } from '@angular/core';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { DataService } from '../../../utils/data.service';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { generalService } from '../../../services/general.service';
import * as moment from 'moment';
import { agregarEntradaComponent } from '../agregar/agregarEntrada.component';
import { config } from 'process';
import { Subscription } from 'rxjs';

@Component ({
  selector: 'historialEntrada-component',
  styles: [],
  templateUrl: 'historialEntrada.component.html',
  providers: [generalService]
})

export class historialEntradaComponent {
  clickEventsubscription:Subscription;
  constructor(private _generalService: generalService, 
              public dialog: MatDialog, 
              public dataService: DataService) {
    this.historialEntradas = new Array();
    this.dataService.guardado = false;     
    this.dataService.tipo = "";     
    this.filtros = {
      idSucursal: this.idSucursal,
      rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
      rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD') };

    this.clickEventsubscription = 
      this._generalService
        .getClickEvent()
          .subscribe(()=>{  this.entradasGetTable(); })
  }
  
  dataEntradas: DataSourceGrid | null;
  displayedColumns = ['columnaI', 'columnaII', 'columnaIII', 'columnaIV', 'columnaV', 'columnaVI'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  locale: {
    format: 'DD-MM-YYYY', 
    separator: ' - ',
    firstDay: 1 };
  ranges: any = {
    'Hoy': [moment(), moment()],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()] };
  
  public dateRange: any = {
    startDate: moment().startOf('month'),
    endDate: moment()   };
  public historialEntradas: Array<any>;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public idSucursal:number = this.userData.ORGANIZATION_ID;
  public filtros: any;

  ngOnInit() {
    this.entradasGetTable()
  }

  ngModelChange(valor){ 
    this.filtros.rangoInicio = valor.startDate.format('YYYY-MM-DD');
    this.filtros.rangoFinal = valor.endDate.format('YYYY-MM-DD');
    this.entradasGetTable();  //Preguntarle a Juda en que caso se requiere esta llamada al método
  }

  entradasGetTable() {
    let tipo = 'agregar';
    let string = "EntradaAlmacen/entradasGetTable";

    this._generalService
      .metodoCallParamsPutPost(tipo, this.filtros, string)
        .subscribe(result => {
          this.historialEntradas = JSON.parse(result);
          this.dataEntradas = new DataSourceGrid(this.historialEntradas, this.paginator, this.sort);
          if(this.historialEntradas.length <= 0)
            { $(".mat-row").remove(".mat-row"); }
        }, error => 
          {  console.log(<any>error);  }
    );
  }

  entradasGoToEdit(idEntrada){
    this.dataService.tipo = "editar";
    this.dataService.id = idEntrada;
    const dialogRef = this.dialog.open(agregarEntradaComponent, {disableClose: true, 
      width:'100%', maxWidth:'70%', panelClass: 'full-width-dialog', height:'100%', maxHeight:'90%'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      this.entradasGetTable();  
      this.dataService.tipo = "";
    });
  }

  entradasDelete(entrada) {
    const eliminarHttp = new EventEmitter();
    eliminarHttp.subscribe((ok) => {
      this._generalService.toastCall(ok.message);
      this.entradasGetTable();
    });
    this._generalService.modal(eliminarHttp,
                               'confirm',
                               `¿Desea eliminar la entrada #${entrada.noEntrada}?`,
                               'EntradaAlmacen/entradaDelete',
                               entrada.idEntrada);
  }

  entradasReadOnly(idEntrada){
    this.dataService.tipo = "ver";
    this.dataService.id = idEntrada;
    const dialogRef = this.dialog.open(agregarEntradaComponent, {disableClose: true, 
      width:'100%', maxWidth:'70%', panelClass: 'full-width-dialog', height:'100%', maxHeight:'90%'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      this.entradasGetTable();  
      this.dataService.tipo = "";
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/almacen/entradas/historial/historialEntrada.component.ts